import { sentenceCase } from "change-case"
import { serviceTypes } from "~/app/utils/rubyConstants"

export const DOCUMENT_MIME_TYPES = [
  ".csv",
  ".doc",
  ".docx",
  ".numbers",
  ".pages",
  ".pdf",
  ".rtf",
  "application/vnd.ms-excel", // .xls
  "application/vnd.oasis.opendocument.presentation", // .odp
  "application/vnd.oasis.opendocument.spreadsheet", // .ods
  "application/vnd.oasis.opendocument.text", // .odt
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xls
  "image/*",
].join(",")

export const SERVICE_TYPES = serviceTypes.map(service => ({
  label: sentenceCase(service),
  value: service,
}))
